module.exports = __webpack_public_path__ + "static/media/home.bc33abc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/Result/images/home.svg
// module id = 941
// module chunks = 0